export enum MaskingType {
    NONE = 'N',
    PARTIAL = 'P',
    FULL = 'F'
  }
  